import React from 'react';
import PropTypes from 'prop-types';
import styles from './ResultIndicator.module.css';

const ResultIndicator = ({ label, value, prefix = '' }) => {
  return (
    <div className={styles.resultValue}>
      <div className={styles.resultLabel}>{label}</div>
      <div className={styles.resultNumber}>
        {prefix}{value}
      </div>
    </div>
  );
};

ResultIndicator.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  prefix: PropTypes.string
};

ResultIndicator.defaultProps = {
  prefix: ''
};

export default ResultIndicator;
